import React, {useEffect, useMemo, useState} from 'react'
import {eventosOrdinariosFields} from "./eventos-ordinarios-fields"
import {Stack} from "@mui/material"
import PropTypes from "prop-types"
import {copyTable, pasteTableFromClipboard} from "../../../../utils/csv-utils"
import MotorEventosOrdinariosService from "../../../../../../../services/motor-eventos-ordinarios-service"
import DynamicColumnTable from "../../../componentes/dynamic-column-table"
import {mapEventosOrdinariosToTable} from "./map-eventos-ordinarios"
import {useLocation} from "react-router-dom"

const EventosOrdinariosTable = (
    {
        setLoading,
        idCaracteristica,
        eventoPublicado,
        tableData,
        setTableData,
        clearTable
    }) => {
    const eventosService = useMemo(() => new MotorEventosOrdinariosService(), [])
    const [tableKey, setTableKey] = useState(Math.random() * 10)
    const location = useLocation()
    const navigationState = location.state

    useEffect(() => {
        const {origem} = navigationState
        if (origem === undefined || origem === "ver" && idCaracteristica !== undefined) {
            loadEventosOrdinarios()
        }
    }, [idCaracteristica])

    useEffect(() => {
        const {origem} = navigationState
        if (origem === "duplicar") {
            const {Data, CETIP, VersaoDocumento} = navigationState
            const {EventosOrdinarios} = Data

            if (EventosOrdinarios !== null) {
                const {Eventos} = EventosOrdinarios
                const {Caracteristica} = Data
                const {Caracteristica: {IDEmissao}} = Caracteristica
                setTableData(mapEventosOrdinariosToTable(Eventos, CETIP, VersaoDocumento, IDEmissao))
            }
        }
    }, [])

    useEffect(() => {
        const {origem, eventos} = navigationState
        if (origem === "projetar") {
            setTableData(mapEventosOrdinariosToTable(eventos))
        }
    }, [])

    const loadEventosOrdinarios = () => {
        setLoading(true)
        eventosService.getEventosOrdinarios(idCaracteristica)
            .then(response => {
                const {body} = response

                if (body && body.length > 0) {
                    eventoPublicado(true)
                    const formatted = mapEventosOrdinariosToTable(body)
                    setTableData(formatted)

                    setTableKey(Math.random() * 10)
                } else {
                    loadEventosOrdinariosTemporario()
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    const loadEventosOrdinariosTemporario = () => {
        eventosService.getTemporarioEventosOrdinarios(idCaracteristica)
            .then(response => {
                const bodyTemp = response?.body?.Eventos || response?.data?.Eventos

                if (bodyTemp && bodyTemp.length > 0) {
                    eventoPublicado(false)
                    const formatted = mapEventosOrdinariosToTable(bodyTemp)
                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    return <Stack sx={{mt: 0}}>
        <DynamicColumnTable
            key={tableKey}
            height={600}
            actionButtons={true}
            copyData={() => copyTable(tableData, eventosOrdinariosFields)}
            clearTable={() => clearTable(setTableData)}
            pasteData={async () => await pasteTableFromClipboard(eventosOrdinariosFields, setTableData)}
            fields={eventosOrdinariosFields}
            items={tableData}
            setItems={setTableData}
        />
    </Stack>
}

EventosOrdinariosTable.propTypes = {
    setLoading: PropTypes.bool,
    idCaracteristica: PropTypes.number,
    eventoPublicado: PropTypes.func,
    tableData: PropTypes.array,
    setTableData: PropTypes.func,
    clearTable: PropTypes.func,
}

export default EventosOrdinariosTable